// extracted by mini-css-extract-plugin
export default {"announcementDetail":"index_announcementDetail__+lWED"};